import type { MapValidationError } from '../game/model/validateMap'

/** Lowercase a-z, 0-9, hyphen only. No path-like segments. */
const MAP_ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/

export function isValidMapId(id: string): boolean {
  if (!id || id.length > 64) return false
  if (id.includes('..') || id.includes('/') || id.includes('\\')) return false
  return MAP_ID_PATTERN.test(id)
}

export function normalizeMapId(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

export function formatValidationError(error: MapValidationError): string {
  const rule = error.rule
  if (
    rule.startsWith('path') ||
    rule.startsWith('spawn') ||
    rule.startsWith('exit') ||
    rule === 'dimensions' ||
    rule === 'row-count' ||
    rule === 'row-length' ||
    rule === 'tile' ||
    rule === 'simple-path' ||
    rule === 'starting-gold' ||
    rule === 'starting-lives' ||
    rule === 'schema-version'
  ) {
    return `MAP: ${error.message}`
  }

  const waveMatch = error.message.match(/^wave\s+([^\s]+)/i)
  if (waveMatch) {
    return `WAVE ${waveMatch[1]}: ${error.message}`
  }
  if (rule.startsWith('wave') || rule.startsWith('group')) {
    return `WAVES: ${error.message}`
  }
  return error.message
}

export function confirmDiscardIfDirty(isDirty: boolean, actionLabel: string): boolean {
  if (!isDirty) return true
  return window.confirm(`Discard unsaved changes and ${actionLabel}?`)
}
